import * as Sentry from '@sentry/react'
import { redactUrl } from './lib/redactUrl'

// Every URL-shaped field must be redacted before send: /auth/confirmed and /auth/callback URLs carry live Supabase tokens.
function redactEvent(event: Sentry.ErrorEvent): Sentry.ErrorEvent {
  if (event.request?.url) {
    event.request.url = redactUrl(event.request.url)
  }
  for (const crumb of event.breadcrumbs ?? []) {
    for (const key of ['url', 'from', 'to'] as const) {
      const value = crumb.data?.[key]
      if (typeof value === 'string') crumb.data![key] = redactUrl(value)
    }
  }
  return event
}

export function initSentry(dsn = import.meta.env.VITE_SENTRY_DSN as string) {
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    beforeSend(event) {
      if (event.level !== 'error' && event.level !== 'warning') return null
      return redactEvent(event)
    },
  })
}
